import React, { useState, useEffect } from 'react';
const Mp4Icon = (props) => {
    const strokeColor = props.stroke || '#262A33';
    const [id, setId] = useState(`${Math.random()}`);
    useEffect(() => {
        const id = `${Math.random()}`;
        setId(id);
    }, []);
    const attribute = Object.assign({}, props);
    delete attribute.stroke;
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, attribute),
        React.createElement("path", { d: "M4.66667 0H16.6667L22 5.33333V22C22 23.1046 21.1046 24 20 24H4.66667C3.19391 24 2 22.8061 2 21.3333V2.66667C2 1.19391 3.19391 0 4.66667 0Z", fill: `url(#${id})` }),
        React.createElement("path", { d: "M15.8062 12.7742C16.2109 13.0371 16.2109 13.6295 15.8062 13.8924L9.69679 17.8606C9.25328 18.1487 8.66699 17.8304 8.66699 17.3015L8.66699 9.36512C8.66699 8.83627 9.25328 8.51797 9.6968 8.80604L15.8062 12.7742Z", fill: "white" }),
        React.createElement("path", { d: "M16.667 4V0L22.0003 5.33333H18.0003C17.2639 5.33333 16.667 4.73638 16.667 4Z", fill: "white", fillOpacity: "0.5" }),
        React.createElement("defs", null,
            React.createElement("linearGradient", { id: id, x1: "12", y1: "0", x2: "12", y2: "24", gradientUnits: "userSpaceOnUse" },
                React.createElement("stop", { stopColor: "#A7A9F9" }),
                React.createElement("stop", { offset: "1", stopColor: "#8283F7" })))));
};
export default Mp4Icon;
